import React from 'react'
import moment from 'moment'
import {ImageBuffer} from '../..'

import './viewEnrollmentProfile.css'

const ViewEnrollmentProfile = ({enrollmentData}: any) => {

  return (
      <>
        <div className='view-enrollment-profile-body-wrapper'>
          <div className='view-enrollment-profile-body-head'>
            <h3>Enrollment information</h3>
          </div>
          
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              Image:
            </div>
            <div className='view-enrollment-profile-details-main'>
              <ImageBuffer src={enrollmentData?.selectedFile} alt='user img' />
            </div>
          </div>

          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              first name:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {enrollmentData?.firstName}
            </div>
          </div>
          
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              last name:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {enrollmentData?.lastName}
            </div>
          </div>
  
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              sex:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {enrollmentData?.sex}
            </div>
          </div>
  
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              Email Address:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {enrollmentData?.emailAddress}
            </div>
          </div>
  
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              primary Phone:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {enrollmentData?.phoneNumber}
            </div>
          </div>
  
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              Resume:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {enrollmentData?.resume}
            </div>
          </div>
  
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              created:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {moment(enrollmentData?.createdAt).format('YYYY-MM-DD H:s:m')} 
            </div>
          </div>
  
          <div className='view-enrollment-profile-body-details-wrapper'>
            <div className='view-enrollment-profile-details-title'>
              updated:
            </div>
            <div className='view-enrollment-profile-details-main'>
              {moment(enrollmentData?.updatedAt).format('YYYY-MM-DD H:s:m')} 
            </div>
          </div>
        </div>
      </>
    )
}

export default ViewEnrollmentProfile